import { render, staticRenderFns } from "./AuthorizePopup.vue?vue&type=template&id=58e88b6e&scoped=true&"
import script from "./AuthorizePopup.vue?vue&type=script&lang=js&"
export * from "./AuthorizePopup.vue?vue&type=script&lang=js&"
import style0 from "./AuthorizePopup.vue?vue&type=style&index=0&id=58e88b6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e88b6e",
  null
  
)

export default component.exports